import { ReactElement } from 'react';
import { Column, Row } from 'react-table';

import { UploadType } from '../../../../shared/models';
import { isRejectedUpload } from '../../../../shared/utils';
import { DocumentListNameCell } from '../../documents/components';
import { UploadStatusLabel } from '../components';

export const getUploadListColumns = (
  actionsCellRenderer: ({ row }: { row: Row<UploadType> }) => ReactElement
): Column<UploadType>[] => [
  {
    Header: () => <div className="ml-8">Name</div>,
    id: 'fileName',
    disableSortBy: true,
    accessor: (row) => row.file.name,
    Cell: ({ row }: { row: Row<UploadType> }) => (
      <DocumentListNameCell
        isSearching={false}
        value={row.original.file.name}
        row={{ id: row.original.id, isFolder: false, extension: 'txt' }}
      />
    ),
  },
  {
    Header: 'Path',
    id: 'path',
    disableSortBy: true,
    accessor: (row) => row.path,
    Cell: ({ row }: { row: Row<UploadType> }) => (
      <span data-for="path-tooltip" data-tip={row.original.path}>
        {row.original.path}
      </span>
    ),
  },
  {
    Header: 'Status',
    id: 'status',
    disableSortBy: true,
    accessor: 'status',
    Cell: ({ row }: { row: Row<UploadType> }) => (
      <UploadStatusLabel
        status={row.original.status}
        error={isRejectedUpload(row.original) ? row.original.error : undefined}
      />
    ),
  },
  {
    Header: '',
    id: 'actions',
    Cell: actionsCellRenderer,
  },
];
